<script>
    import PortableText from '$lib/components/PortableText.svelte';

    export let content = {};
    export let modulePosition;
    export let sectionPosition;

    // Style
    let moduleStyle = '';
    switch (content?.style) {
        case 'None':
            moduleStyle = '';
            break;
        case 'Framed':
            moduleStyle = 'rounded-xl border border-base-900/5 bg-base-900 p-4 shadow-sm lg:p-8';
            break;
        case 'Gradient Framed':
            moduleStyle = 'featured-gradient rounded-xl p-4 shadow-sm lg:p-8';
            break;
        default:
            moduleStyle = '';
            break;
    }
</script>

<div class={moduleStyle} data-moduleposition={modulePosition}>
    <PortableText data={content?.body} alignment={content?.textAlignment} width={content?.bodyWidth} />
</div>
